import React, { useEffect, useState } from "react";
import axios from "axios";
import { ApiConstant } from "../constants";
import { withRouter } from "react-router-dom";

const Announcement = (props) => {

  const [announcement, setAnnoucement] = useState(null);

  const checkAnnouncement = () => {
    axios
      .post(`${ApiConstant.BASE_URL}common/`, { action: "GET_ANNOUNCEMENT" })
      .then(response => {
        const data = response.data;
        if (data.success && data.result && data.result.length > 0) {
          const announcement = data.result[0].content;
          setAnnoucement(announcement);
        }
        else {
          setAnnoucement(null);
        }
      }).catch((e) => {
        console.log(e);
        setAnnoucement(null);
      });
  };

  if (localStorage.getItem('checkAnnouncementCalled') === 'false') {
    /* Even when the URL not changed, still need to check because Admin can turn on/off announcement at any time */
    checkAnnouncement();
    setInterval(checkAnnouncement, 5 * 60 * 1000);
    localStorage.setItem('checkAnnouncementCalled', true);
  }

  return (
    <>
      {announcement && (
        <div className="announcement">
          <span
            id="question"
            dangerouslySetInnerHTML={{ __html: announcement }}
          ></span>
        </div>
      )}
    </>
  );
};

export default withRouter(Announcement);
